module.exports = {
  loginModule: {
    email: '邮箱',
    password: '密码',
    validCode: '验证码',
    verificationCode: '验证码',
    login: "登录",
    forgotPassword: '忘记密码',
    register: '注册',
    agreement: "我已阅读并同意本",
    privacyPolicy: '隐私政策',
    projectName: "Support Portal",
    passwordRetrieval: "密码检索",
    forgotPassHint: "验证码已发送到您的邮箱。",
    noCode: '没有收到验证码?',
    sendAgain: '重新发送',
    newPassword: "新密码",
    confirmPassword: '确认新密码',
    next: "下一步",
    confirm: "确认",
    sendCode: '发送验证码',
    haveAccount: "已有一个账户?",
    checkCode: '验证码',
    check: '验证',
    companyName: '公司名称',
    tel: '电话',
    address: '地址',
    countryRegion: '国家/区域',
    state: '省',
    city: '市',
    industry: '行业',
    firstName: '名',
    lastName: '姓',
  }
}